import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Temperature extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: number): Temperature {
    if (value < 0) {
      throw new Error('正数である必要があります');
    }
    return new Temperature(value);
  }

  /** ラベル */
  static get label(): string {
    return '体温(℃)';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '36.5';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {};
  }

  /** キー */
  static get key() {
    return 'temperature';
  }

  /** タイプ */
  static get type() {
    return 'number';
  }
}
